import React, { PropTypes } from 'react'

import fbLogo from '../../../images/social-media/facebook-logo-coloured.png';
import instagramLogo from '../../../images/social-media/instagram-logo-colour.png';

class MediaLinks extends React.Component {
  render () {
    return (
      <section id="media-links">
        <div className="container">
          <div className="centered-content">
            <h1 className="uppercase">Follow us on</h1>
            <a className="logo center" href="https://www.facebook.com/herbalaktivpeel/" target="_blank">
              <img src={ fbLogo } alt="Herbal Aktiv Peel Facebook Link" />
            </a>
            <a className="logo" href="https://www.instagram.com/herbalaktivpeel/" target="_blank">
              <img src={ instagramLogo } alt="Herbal Aktiv Peel Instagram Link" />
            </a>
          </div>
        </div>
      </section>
    )
  }
}

export default MediaLinks;



/** WEBPACK FOOTER **
 ** ./src/components/containers/social-media/MediaLinks.jsx
 **/